import { tv } from "tailwind-variants";

export const contentResultListHit = tv({
    base: [
        "tw:p-4 tw:shadow-card tw:rounded-md tw:transition-transform",
        "tw:hover:shadow-card-active tw:hover:scale-102"
    ]
});
